import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Extrafinancial from "./Extrafinancial"
import TravelPassenger from "./TravelPassenger"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceTravel extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  travel_price_id: "",
                  selectedCompany: "",
                  selectedTravelTime: "",
                  selectedCovarage: "",
                  selectedPlan: "",
                  selectedHelper: "",
                  travel_price_desc: "",
                  travel_price_disc: "",
                  travel_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "travel_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceTravel: true,
                  optionCompany: [],
                  optionTravelTime: [],
                  optionCovarage: [],
                  optionPlan: [],
                  optionHelper: [],
                  openDialog: false,
                  travelPassenger: [],
                  travel_price_passenger_price: "",
                  selectedTravelPassenger: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleCovarage = (selectedCovarage) => {
            this.setState({ selectedCovarage: selectedCovarage }, () => {})
      }
      handlePlan = (selectedPlan) => {
            this.setState({ selectedPlan: selectedPlan }, () => {})
      }

      handleHelper = (selectedHelper) => {
            this.setState({ selectedHelper: selectedHelper }, () => {})
      }

      handleTravelTime = (selectedTravelTime) => {
            this.setState({ selectedTravelTime: selectedTravelTime }, () => {
                  this.filterPriceTravel()
            })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceTravel()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ travel_price_deactive: "0" })
            } else {
                  this.setState({ travel_price_deactive: "1" })
            }
      }

      handleTravelPassenger = (selectedTravelPassenger) => {
            this.setState({ selectedTravelPassenger: selectedTravelPassenger })
      }

      handleChangeTravelPassenger = (event) => {
            this.setState({ travel_price_passenger_price: event.target.value })
      }

      handleSelectRows = (row2) => {
            this.gettravelPassenger(row2.travel_price_id)
            this.setState(
                  {
                        travel_price_id: row2.travel_price_id,

                        selectedCompany: { value: row2.travel_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedTravelTime: { value: row2.travel_price_time_id, label: row2.travel_time_name },
                        selectedCovarage: { value: row2.travel_price_coverage_id, label: row2.travel_coverage_name },
                        selectedPlan: { value: row2.travel_price_plan_id, label: row2.travel_plan_name },
                        selectedHelper: { value: row2.travel_price_helper_id, label: row2.travel_helper_name },
                        travel_price_desc: row2.travel_price_desc,
                        travel_price_disc: row2.travel_price_disc,

                        travel_price_deactive: row2.travel_price_deactive,
                        company_logo_url: row2.company_logo_url,
                        newPriceTravel: false,
                  },
                  () => {}
            )
      }

      newPriceTravel = (event) => {
            this.setState({
                  travel_price_id: "",
                  selectedCompany: "",
                  selectedTravelTime: "",
                  selectedCovarage: "",
                  selectedPlan: "",
                  selectedHelper: "",
                  travel_price_deactive: "0",
                  company_logo_url: "",
                  travel_price_desc: "",
                  travel_price_disc: "0",
                  newPriceTravel: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceTravel()
                                    self.getoptionCompany()
                                    self.getoptionTravelTime()
                                    self.getoptionCovarage()
                                    self.getoptionPlan()
                                    self.getoptionHelper()
                                    self.getoptionTravelPassenger()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deletePriceTravel = () => {
            const { travel_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceTravel()
                              self.newPriceTravel()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_travel_price")
            fd.append("travel_price_id", travel_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceTravel() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceTravel()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_price")

            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      gettravelPassenger(travel_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ travelPassenger: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ travelPassenger: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_passenger")
                  fd.append("travel_price_id", travel_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceTravel()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "travelins")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionTravelTime = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_time_id, label: arr.data[k].travel_time_name })
                              }
                              self.setState({ optionTravelTime: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_time")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      getoptionTravelPassenger = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_passenger_id, label: arr.data[k].travel_passenger_name })
                              }
                              self.setState({ optionTravelPassenger: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_passenger")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      getoptionCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_coverage_id, label: arr.data[k].travel_coverage_name })
                              }
                              self.setState({ optionCovarage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      getoptionPlan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_plan_id, label: arr.data[k].travel_plan_name })
                              }
                              self.setState({ optionPlan: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_plan")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      getoptionHelper = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_helper_id, label: arr.data[k].travel_helper_name })
                              }
                              self.setState({ optionHelper: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_helper")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      saveNewPriceTravel = () => {
            const {
                  travel_price_disc,
                  travel_price_desc,
                  selectedCompany,
                  selectedTravelTime,
                  selectedCovarage,
                  selectedPlan,
                  selectedHelper,
                  travel_price_deactive,
            } = this.state
            if (
                  selectedCompany != "" &&
                  selectedTravelTime != "" &&
                  selectedCovarage != "" &&
                  selectedPlan != "" &&
                  selectedHelper != "" &&
                  travel_price_disc != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceTravel()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_travel_price")

                  fd.append("travel_price_fieldcompany_id", selectedCompany.value)
                  fd.append("travel_price_time_id", selectedTravelTime.value)
                  fd.append("travel_price_coverage_id", selectedCovarage.value)
                  fd.append("travel_price_plan_id", selectedPlan.value)
                  fd.append("travel_price_helper_id", selectedHelper.value)
                  fd.append("travel_price_desc", travel_price_desc)
                  fd.append("travel_price_disc", travel_price_disc)
                  fd.append("travel_price_deactive", travel_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceTravelTime = () => {
            const { travel_price_id, selectedTravelPassenger, travel_price_passenger_price } = this.state
            if (selectedTravelPassenger != "" && travel_price_passenger_price != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ travel_price_passenger_price: "", selectedTravelPassenger: "" })
                                    self.gettravelPassenger(travel_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_passenger")
                  fd.append("travel_price_passenger_travel_price_id", travel_price_id)
                  fd.append("travel_price_passenger_price", travel_price_passenger_price)
                  fd.append("travel_price_passenger_travel_passenger_id", selectedTravelPassenger.value)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceTravel2 = () => {
            const {
                  travel_price_id,
                  travel_price_disc,
                  travel_price_desc,
                  selectedCompany,
                  selectedTravelTime,
                  selectedCovarage,
                  selectedPlan,
                  selectedHelper,
                  travel_price_deactive,
            } = this.state
            if (
                  selectedCompany != "" &&
                  travel_price_disc != "" &&
                  selectedTravelTime != "" &&
                  selectedCovarage != "" &&
                  selectedPlan != "" &&
                  selectedHelper != "" &&
                  selectedHelper != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceTravel()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_travel_price")
                  fd.append("travel_price_id", travel_price_id)

                  fd.append("travel_price_fieldcompany_id", selectedCompany.value)
                  fd.append("travel_price_time_id", selectedTravelTime.value)
                  fd.append("travel_price_coverage_id", selectedCovarage.value)
                  fd.append("travel_price_plan_id", selectedPlan.value)
                  fd.append("travel_price_helper_id", selectedHelper.value)
                  fd.append("travel_price_desc", travel_price_desc)
                  fd.append("travel_price_disc", travel_price_disc)
                  fd.append("travel_price_deactive", travel_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }
      handleChangeDesc = (event) => {
            this.setState({ travel_price_desc: event.target.value })
      }
      handleChangeDisc = (event) => {
            this.setState({ travel_price_disc: event })
      }
      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceTravel = () => {
            const { selectedCompany, selectedTravelTime, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedCompany.value === 0 || temparray[i].travel_price_fieldcompany_id === selectedCompany.value) &&
                        (selectedTravelTime === "" ||
                              selectedTravelTime.value === 0 ||
                              temparray[i].travel_price_time_id === selectedTravelTime.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            console.log(requestinfos)
            console.log(temparray2)
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  travel_price_passenger_price,
                  travel_price_disc,
                  travel_price_desc,
                  selectedTravelPassenger,
                  optionCompany,
                  optionTravelPassenger,
                  optionTravelTime,
                  optionCovarage,
                  optionPlan,
                  optionHelper,
                  travelPassenger,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceTravel,
                  travel_price_id,
                  company_logo_url,
                  selectedCompany,
                  selectedTravelTime,
                  selectedCovarage,
                  selectedPlan,
                  selectedHelper,
                  travel_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه مسافرتی: " + travel_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">مدت زمان بیمه نامه </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"مدت زمان بیمه نامه "}
                                                                              value={selectedTravelTime}
                                                                              onChange={this.handleTravelTime}
                                                                              options={optionTravelTime}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">پوشش بیمه نامه </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"پوشش بیمه نامه"}
                                                                              value={selectedCovarage}
                                                                              onChange={this.handleCovarage}
                                                                              options={optionCovarage}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">پلن مسافرتی</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"پلن مسافرتی"}
                                                                              value={selectedPlan}
                                                                              onChange={this.handlePlan}
                                                                              options={optionPlan}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">کمک رسان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کمک رسان"}
                                                                              value={selectedHelper}
                                                                              onChange={this.handleHelper}
                                                                              options={optionHelper}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="تخفیف"
                                                                        handleInputt={this.handleChangeDisc}
                                                                        value={travel_price_disc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات"
                                                                        handleInputt={this.handleChangeDesc}
                                                                        value={travel_price_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={travel_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceTravel ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewPriceTravel}>
                                                                              {"ثبت قیمت بیمه مسافرتی جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceTravel}
                                                                              >
                                                                                    {"قیمت بیمه مسافرتی جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceTravel2}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه مسافرتی"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceTravel ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceTravel ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {travelPassenger.map((travelPassenger, index) => (
                                                                        <TravelPassenger
                                                                              travelPassenger={travelPassenger}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceTravel ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on">بازه سن مسافران </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"بازه سن مسافران"}
                                                                                          value={selectedTravelPassenger}
                                                                                          onChange={this.handleTravelPassenger}
                                                                                          options={optionTravelPassenger}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    placeholder="قیمت بیمه نامه "
                                                                                    handleInputt={this.handleChangeTravelPassenger}
                                                                                    value={travel_price_passenger_price}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceTravelTime}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"travel_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "travel_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_price_id"}
                                                                                          direction={orderBy === "travel_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"travel_price_time_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مدت بیمه نامه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_price_time_id"}
                                                                                          direction={
                                                                                                orderBy === "travel_price_time_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_price_time_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_price_coverage_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"پوشش بیمه نامه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_price_coverage_id"}
                                                                                          direction={
                                                                                                orderBy === "travel_price_coverage_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_price_coverage_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_price_plan_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"پلن مسافرتی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_price_plan_id"}
                                                                                          direction={
                                                                                                orderBy === "travel_price_plan_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_price_plan_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_price_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_price_disc"}
                                                                                          direction={orderBy === "travel_price_disc" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_price_disc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه مسافرتی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "travel_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["travel_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"travel_price_id"} align={"center"}>
                                                                                                      {row["travel_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"travel_price_time_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_time_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"travel_price_coverage_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_coverage_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"travel_price_plan_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_plan_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"travel_price_disc"} align={"center"}>
                                                                                                      {row["travel_price_disc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"travel_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_price_deactive"] === "1" ||
                                                                                                      row["travel_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه مسافرتی را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deletePriceTravel} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceTravel)
